// Radios belong to the native product form: quantities work with AJAX and normal form submission.
class DooboBundlePicker extends HTMLElement {
  connectedCallback() {
    this.addEventListener('change', this.updatePrice);
    this.updatePrice();
  }

  disconnectedCallback() {
    this.removeEventListener('change', this.updatePrice);
  }

  updatePrice = () => {
    const selected = this.querySelector('input:checked');
    if (!selected) return;
    const template = this.querySelector(`template[data-bundle-price="${selected.dataset.packs}"]`);
    const scope = this.closest('.shopify-section, dialog');
    if (!template || !scope) return;
    for (const price of scope.querySelectorAll(`[data-doobo-product-id="${this.dataset.productId}"]`)) {
      price.replaceChildren(template.content.cloneNode(true));
      price.classList.add('doobo-variety-price');
      price.setAttribute('aria-live', 'polite');
    }
    const form = document.getElementById(this.dataset.formId);
    const component = form?.closest('product-form-component');
    if (component) component.dataset.quantityDefault = selected.value;
    const sticky = scope.querySelector(`sticky-add-to-cart[data-product-id="${this.dataset.productId}"]`);
    if (sticky) {
      const label = sticky.querySelector('.sticky-add-to-cart__variant');
      if (label) label.textContent = `${selected.dataset.packs} ${selected.dataset.packs === '1' ? 'Pack' : 'Packs'}`;
      // The sticky button submits the same product form; the pack label gives its quantity.
      const counter = sticky.querySelector('[ref="quantityDisplay"]');
      if (counter) counter.hidden = true;
    }
  };
}

if (!customElements.get('doobo-bundle-picker')) {
  customElements.define('doobo-bundle-picker', DooboBundlePicker);
}
